import { useEffect, useState } from "react";
import { Share, X } from "lucide-react";

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("fp_pwa_dismissed")) return;
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (standalone) return;
    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    setIos(isIos);
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    if (isIos) {
      const t = setTimeout(() => setVisible(true), 2500);
      return () => clearTimeout(t);
    }
    window.addEventListener("beforeinstallprompt", onPrompt);
    const t = setTimeout(() => setVisible(true), 2500);
    return () => {
      clearTimeout(t);
      window.removeEventListener("beforeinstallprompt", onPrompt);
    };
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem("fp_pwa_dismissed", "1");
    setVisible(false);
  };

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      const choice = await deferred.userChoice;
      if (choice.outcome === "accepted") dismiss();
      else setVisible(false);
      setDeferred(null);
    }
  };

  return (
    <div
      data-testid="install-prompt"
      className="fixed bottom-24 left-4 right-4 sm:left-6 sm:right-auto z-[60] rounded-2xl border border-[rgba(28,19,14,0.12)] bg-[#FDFBF7]/95 backdrop-blur-md shadow-xl px-5 py-4 flex items-center gap-4"
    >
      <div className="grid place-items-center w-10 h-10 rounded-full bg-[#1C130E] text-[#FDFBF7] shrink-0">
        <Share size={15} />
      </div>
      <div className="min-w-0">
        <p className="text-sm font-semibold text-[#1C130E]">French Pie on your home screen</p>
        <p className="text-xs text-[#1C130E]/60 leading-snug mt-0.5">
          {ios ? "In Safari: tap Share, then Add to Home Screen." : "Install the app — one tap, opens like native."}
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0 ml-auto">
        {!ios && deferred && (
          <button
            onClick={install}
            data-testid="install-confirm-btn"
            className="rounded-full bg-[#C85A32] text-[#FDFBF7] px-4 py-2 text-xs font-semibold hover:bg-[#a94b29] transition-colors"
          >
            Install
          </button>
        )}
        <button
          onClick={dismiss}
          data-testid="install-dismiss-btn"
          aria-label="Dismiss install prompt"
          className="grid place-items-center w-8 h-8 rounded-full text-[#1C130E]/50 hover:bg-[#1C130E]/[0.06] transition-colors"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};
